import { render } from "./EmptyMessage.vue?vue&type=template&id=4aa8fd19&scoped=true"
const script = {}

import "./EmptyMessage.vue?vue&type=style&index=0&id=4aa8fd19&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa8fd19"]])

export default __exports__